import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  link: {
    color: theme.palette.link.main,
    fontWeight: '400',
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    '&:hover': {
      fontWeight: 400,
    },
  },
}));

export const cardRootStyles = makeStyles(() => ({
  root: {
    padding: '0 1rem',
  },
}));

export const listTextStyles = makeStyles(() => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    primary: {
      display: 'inline-block',
      fontWeight: 'bold',
      fontSize: '0.875rem',
    },
    secondary: {
      display: 'inline-block',
      fontSize: '0.875rem',
    },
  };
});

export const collapseCardStyles = makeStyles({
  root: {
    marginTop: 20,
    marginBottom: 20,
    '& button': {
      borderRadius: '4px 4px 0 0',
    },
  },
  box: {
    marginTop: 0,
    borderTop: 0,
    borderRadius: '0 0 4px 4px',
  },
  buttonClass: {
    backgroundColor: '#FBFBFB',
    border: '1px solid #EEEEEE',
    boxShadow: 'none',
    color: '#4D4F5C',
    padding: '6px 24px',
    textTransform: 'capitalize',
    fontSize: '13px',
    '&:hover': {
      backgroundColor: '#FBFBFB',
      border: '1px solid #EEEEEE',
      boxShadow: 'none',
      color: '#4D4F5C',
    },
  },
});
